export default function resetScroll(top = 0) {
  // IE does not have a `scrollingElement`, but if it did, it'd be the `document.body`.
  const { scrollingElement = document.body } = document
  scrollingElement.scroll({ behavior: 'smooth', top })
}
